/**
 * @author xinyiliang
 * @date 2019/5/13-11:23
 * @file modal-type-map
 */

export default {
    center: 'center',
    longImg: 'longImg'
};
